import React from 'react';

const Icon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7534 21.8456C12.6174 21.4937 11.8277 20.315 12.1033 19.0283C10.6322 18.0762 10.6322 15.9238 12.1033 14.9717C11.7363 13.2583 13.2583 11.7363 14.9717 12.1033C15.9238 10.6322 18.0762 10.6322 19.0283 12.1033C20.315 11.8277 21.4937 12.6174 21.8456 13.7534C22.3962 10.6465 21.4712 7.32933 19.0708 4.92888C15.1656 1.02371 8.83406 1.02371 4.92889 4.92888C1.02371 8.83408 1.0237 15.1656 4.92889 19.0708C7.32932 21.4712 10.6465 22.3962 13.7534 21.8456Z"
        fill="#E8F4FF"
      />
      <path
        d="M12.0689 14.7721C12.0456 14.7718 12.0223 14.7717 11.9989 14.7717C8.93066 14.7717 6.44336 16.7631 6.44336 19.2195V19.7776L11.9989 21.4443L12.7378 21.2226C12.2017 20.6743 11.922 19.8746 12.1033 19.0281C10.6322 18.076 10.6322 15.9236 12.1033 14.9715C12.089 14.9047 12.0775 14.8382 12.0689 14.7721Z"
        fill="#AAA9FA"
      />
      <path
        d="M9.22157 20.608V18.9421C9.22157 18.7885 9.0972 18.6641 8.94379 18.6641C8.79038 18.6641 8.66602 18.7885 8.66602 18.9421V20.4302C8.84977 20.495 9.03504 20.5543 9.22157 20.608Z"
        fill="#8483E7"
      />
      <path
        d="M15.8891 9.20871C15.8891 7.06094 14.148 5.31982 12.0002 5.31982C9.85244 5.31982 8.11133 7.06094 8.11133 9.20871V9.76429H7.83333C7.3731 9.76429 7 10.1374 7 10.5976C7 11.0579 7.3731 11.431 7.83333 11.431H8.11133C8.11134 13.4741 9.68701 15.1493 11.6895 15.3076C11.8113 15.1843 11.9492 15.0714 12.1033 14.9717C11.7363 13.2583 13.2583 11.7363 14.9717 12.1033C15.4264 11.4008 16.1547 11.0338 16.8954 11.0022C16.962 10.8824 17 10.7445 17 10.5976C17 10.1374 16.6269 9.76429 16.1667 9.76429H15.8891V9.20871Z"
        fill="#FFD9C3"
      />
      <path
        d="M15.8895 11.2674V9.20871C15.8895 7.06094 14.1484 5.31982 12.0007 5.31982C11.8599 5.31982 11.7209 5.3273 11.584 5.34189C13.5358 5.54979 15.0562 7.2017 15.0562 9.20871V11.4309C15.0562 11.6416 15.0395 11.8483 15.0072 12.0499C15.2443 11.7032 15.5497 11.4424 15.8895 11.2674Z"
        fill="#F2BB9C"
      />
      <path
        d="M11.2955 7.05562C10.86 8.48913 9.47319 9.93868 7.55443 9.76423C6.24725 8.4689 7.76847 4.26087 10.9612 4.86228C14.8009 2.54567 17.7783 7.05984 16.1648 9.76423C14.5135 10.0395 12.5149 8.78108 11.2955 7.05562Z"
        fill="#775537"
      />
      <path
        d="M15.2752 9.77367C15.5792 9.81356 15.8785 9.81234 16.1672 9.76423C17.5347 7.47216 15.6044 3.8801 12.6465 4.24841C15.1173 4.56598 16.5706 7.69491 15.336 9.76423C15.3158 9.76762 15.2955 9.77073 15.2752 9.77367Z"
        fill="#5A391B"
      />
      <path
        d="M12.9859 12.5554H10.8887C11.0455 13.3938 11.6468 13.7577 12.19 13.6472C12.3472 13.213 12.6267 12.8348 12.9859 12.5554Z"
        fill="white"
      />
      <path
        d="M10.6107 10.1808C10.6107 9.95071 10.4241 9.76416 10.194 9.76416C9.96389 9.76416 9.77734 9.95071 9.77734 10.1808V10.7364C9.77734 10.9665 9.96389 11.153 10.194 11.153C10.4241 11.153 10.6107 10.9665 10.6107 10.7364V10.1808Z"
        fill="#39444F"
      />
      <path
        d="M14.222 10.1808C14.222 9.95071 14.0355 9.76416 13.8053 9.76416C13.5752 9.76416 13.3887 9.95071 13.3887 10.1808V10.7364C13.3887 10.9665 13.5752 11.153 13.8053 11.153C14.0355 11.153 14.222 10.9665 14.222 10.7364V10.1808Z"
        fill="#39444F"
      />
      <path
        d="M12.4566 20.8774C12.3054 20.885 12.1531 20.8889 12 20.8889C7.0908 20.8889 3.11111 16.9092 3.11111 12C3.11111 7.0908 7.0908 3.11111 12 3.11111C16.9092 3.11111 20.8889 7.0908 20.8889 12C20.8889 12.1531 20.885 12.3054 20.8774 12.4566C21.3335 12.7633 21.6814 13.2213 21.8464 13.7558C21.9473 13.1858 22 12.599 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.599 22 13.1858 21.9473 13.7558 21.8464C13.2213 21.6814 12.7633 21.3335 12.4566 20.8774Z"
        fill="#A8CAE9"
      />
      <path
        d="M16.0345 12.6814C16.3576 11.7729 17.6424 11.7729 17.9655 12.6814C18.169 13.2535 18.8225 13.5243 19.371 13.2636C20.2419 12.8496 21.1504 13.7581 20.7364 14.629C20.4757 15.1775 20.7464 15.831 21.3186 16.0345C22.2271 16.3576 22.2271 17.6424 21.3186 17.9655C20.7464 18.169 20.4757 18.8225 20.7364 19.371C21.1504 20.2419 20.2419 21.1504 19.371 20.7364C18.8225 20.4757 18.169 20.7464 17.9655 21.3186C17.6424 22.2271 16.3576 22.2271 16.0345 21.3186C15.831 20.7464 15.1775 20.4757 14.629 20.7364C13.7581 21.1504 12.8496 20.2419 13.2636 19.371C13.5243 18.8225 13.2535 18.169 12.6814 17.9655C11.7729 17.6424 11.7729 16.3576 12.6814 16.0345C13.2535 15.831 13.5243 15.1775 13.2636 14.629C12.8496 13.7581 13.7581 12.8496 14.629 13.2636C15.1775 13.5243 15.831 13.2535 16.0345 12.6814Z"
        fill="#478CC8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.4865 15.2524C19.6626 15.4249 19.6657 15.7075 19.4932 15.8837L16.7352 18.7425C16.6512 18.8283 16.5362 18.8766 16.4161 18.8766C16.2961 18.8766 16.1811 18.8283 16.0971 18.7425L14.5083 17.1193C14.3358 16.9431 14.3388 16.6604 14.515 16.488C14.6912 16.3155 14.9739 16.3185 15.1463 16.4947L16.4161 17.792L18.8551 15.2591C19.0276 15.083 19.3103 15.0799 19.4865 15.2524Z"
        fill="white"
      />
    </svg>
  );
};

export default Icon;
